<app-record-card-generic>
  <ng-template appRecordCardGenericLeft>
    <opac-record-cover
      [coverUrl]="item.cover"
      [icon]="item.icon"
      [isList]="isList"
      [routerLink]="['/info', getRecordSlug(containerRecord)]"
      [queryParams]="{rhId: item.rhId}"></opac-record-cover>
  </ng-template>
  <ng-template appRecordCardGenericRight>
    <p
      class="rss-item__title two-line-title"
      [routerLink]="['/info', getRecordSlug(containerRecord)]"
      [queryParams]="{rhId: item.rhId}"
      [attr.aria-label]="('general.goto' | translate) + ' ' + (item.title)"
      [innerHTML]="item.title"></p>

    <div class="rss-item__actions">
      <app-record-buttons
        from="USER_SCREENS"
        [record]="containerRecord"
        [rssItem]="item"
        [config]="buttonsConfig"></app-record-buttons>
    </div>

    <div class="rss-item__details" tabindex="0">
      <p class="fade-description" [innerHTML]="item.description"></p>
    </div>
  </ng-template>
</app-record-card-generic>
